import BulkOrderAboutPage from '../../../components/pages/bulk_order/about/BulkOrderAboutPage.vue'
export default {
  components: { BulkOrderAboutPage }
}
